import { combineReducers } from "redux";
import documentReducer from "./reducer";

const reducer = combineReducers({
  documentReducer,
});

export default reducer;
